<template>
  <div class="sidebar-root">
    <div class="sidebar" :class="{hideSidebar:toggleNotes}">
      <b-form-textarea ref="textarea" v-show="istextAreaFocused" @blur="renderMarkdown" v-model="input"
                      rows="25" max-rows="25">
      </b-form-textarea>
      <div v-show="!istextAreaFocused"  @click="renderTextArea" v-html="compiledMarkdown"></div>
    </div>
  </div>
</template>

<script>
// import { BSidebar, BButton} from 'bootstrap-vue'
import marked from 'marked';
import _ from 'lodash';

import { BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'sidebar-root',
  props:{
    traits: Array,
    actions: Array,
    legend_actions: Array,
    toggleNotes : Boolean,
  },
  data(){
    return{
      hover : false,
      istextAreaFocused : false,
      input: "# Notes",
    }
  },
  components:{
      'b-form-textarea': BFormTextarea,
  },
  computed: {
    compiledMarkdown: function() {
      return marked(this.input, {
        sanitize: true
      })
    }
  },
  filters: {
    marked,
  },
  methods:{
    update: _.debounce(function(e) {
      this.input = e.target.value
    }, 300),
    renderMarkdown(){
        this.istextAreaFocused = false;
        console.log('test')
    },
    focus(){
        this.$refs.textarea.focus();
    },
    renderTextArea(){
        this.istextAreaFocused = true;
        // very bad workaround
        setTimeout(() => this.$refs.textarea.focus(), 1);
    },
  },
}
</script>


<style> 
/* The sidebar menu */
.sidebar {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 350px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  /* Stay on top */
  z-index: 1;
  /* Stay at the top */
  top: 0; 
  left: 0;
  /* 253,241,220 */
  background-color: rgb(252, 247, 243); /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 80px !important;
  padding: 20px;
  box-shadow: 0 30px 40px rgba(0,0,0,0.5);

}
.hideSidebar{
  visibility: hidden;
  width:1px;
}




p.this{
    display: block;
    position: absolute;
    /* top: 50%; */
    /* left: 50%; */
}
</style>